export default {
  id: null,
  companyID: null,
  areaID: null,
  insuranceID: null,
  businessTypeID: null,
  name: null,
  note: null,
  status: null,
  fieldRule: null,
  valueRule: null,
  typeRule: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/productmodel.js